module.exports = __webpack_public_path__ + "img/toast1-24-ba350df7.png";